import { useEffect, useState } from "react";
import Card from "../components/payment/Card";
import { useInvoice } from "../hooks/useInvoice";
import { ICONS } from "../icons";
import PaymentForm from "../components/payment/PaymentForm";

const PaymentMethod = () => {
  const { wallets } = useInvoice();
  const [methodName, setMethodName] = useState("");

  const walletIcon = {
    ORANGE_MONEY: ICONS.orange,
    MOOV_MONEY: ICONS.moov,
    CORIS_MONEY: ICONS.coris,
    TELECEL_MONEY: ICONS.telecel
  };

  useEffect(() => {
    if (wallets.length > 0) {
      setMethodName(wallets[0].code);
    }
  }, [wallets]);

  return (
    <main className="payment-container">
      <h1 className="amount">Pay with {methodName?.replace(/_/g, " ")}</h1>
      <div className="wallets">
        {wallets.map(
          (wallet) =>
            wallet?.active && (
              <Card
                key={wallet.public_id}
                icon={walletIcon[wallet.code]}
                text={wallet.name}
                isActive={wallet.code === methodName}
                onClick={() => {
                  setMethodName(wallet.code);
                }}
              />
            )
        )}
      </div>
      {methodName && (
        <>
          <h1 className="amount fs-27 weight-normal">
            Enter your wallet details.
          </h1>
          <PaymentForm walletName={methodName} />
        </>
      )}
    </main>
  );
};

export default PaymentMethod;
